let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8325Y")).then(() => parcelRequire('kgUsc'));